import { Container } from '../../../../../../components/container/container';
import { Select } from '../../../../../../components/select/select';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import s from './device-qr-settings.module.css';
import { useDeviceQrSettings } from './use-device-qr-settings';

export const DeviceQrSettings = () => {
  const { qr, branches, handleChangeBranch, handleChangeDescription, handleChangeName, t } =
    useDeviceQrSettings();

  return (
    <div className={s.feature}>
      <Container required label={t('Филиал')}>
        <Select
          options={branches}
          onSelect={handleChangeBranch}
          value={branches.find((item) => item.id === String(qr?.place_id))}
          name="branch"
          data-testid="branch-select"
        />
      </Container>

      <Container required label={t('Название')}>
        <LangInput
          value={qr?.name}
          onChange={handleChangeName}
          name="name"
          data-testid="name-input"
        />
      </Container>
      <Container label={t('Описание')}>
        <LangInput
          value={qr?.description}
          onChange={handleChangeDescription}
          data-testid="description-input"
        />
      </Container>
    </div>
  );
};
